import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PostingFormTrackingSection } from 'remarketing-angular-library';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-form-tracking-modal',
    templateUrl: './form-tracking-modal.component.html',
    styleUrls: ['./form-tracking-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, CommonModule]
})
export class FormTrackingModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Output() continueSubmission = new EventEmitter<void>();

  formTrackingData;

  show(formTrackingData: PostingFormTrackingSection[]) {
    this.formTrackingData = formTrackingData;
    this.modal.show();
  }

  close() {
    this.modal.close();
  }

  continueWithPost() {
    this.modal.close();
    this.continueSubmission.emit();
  }
}
